<!-- The upload-dialog pattern (Figma 12547:40446): heading, the field, one full-width primary action -->
<div class="wrapper flex flex-col" data-testid="drawing-publish-dialog">
  <div class="heading text-type-1 mb-[8px]">Publish drawing set</div>
  <div class="summary text-type-10 mb-[24px]" data-testid="drawing-publish-summary">{{ summary }}</div>

  <form [formGroup]="form">
    <app-text-area [parentFormGroup]="form" controlName="notes" label="CHANGE NOTES" placeholder="What changed in this issue" [maxLength]="5000" />
  </form>

  @if (toAcknowledge.length) {
    <!-- Wrong-drawing guard: the inline warning (Figma 10936:38684); Publish anyway acknowledges these pages -->
    <div class="warnings mt-[16px]" role="alert" data-testid="drawing-publish-warnings">
      <mat-icon class="warnings-icon">warning_amber</mat-icon>
      <div class="warnings-body">
        <div class="warnings-heading">{{ acknowledgeHeading }}</div>
        <ul>
          @for (p of toAcknowledge; track p.uuid) { <li>{{ p.text }}</li> }
        </ul>
      </div>
    </div>
  }

  @if (error) { <div class="publish-error text-type-14 mt-[16px]" role="alert" data-testid="drawing-publish-error">{{ error }}</div> }

  <div class="actions mt-[calc(60px-1.25em)]">
    <app-primary-button buttonId="drawing-publish-confirm" data-testid="drawing-publish-confirm" [isLoading]="publishing" [isDisabled]="publishing" (handleClick)="publish()">{{ publishLabel }}</app-primary-button>
  </div>
</div>
